import { Box } from '@mui/material';
import { useGlobalContext } from '../context/GlobalStore';
import useFetchDevices from '../hooks/useFetchDevices';
import useFetchOrders from '../hooks/useFetchOrders';
import ApiKeySelect from './ApiKeySelect';

const ToggleDatabase = () => {
  const { state, setApiKey, setIsDeviceLoading, setIsOrderLoading } =
    useGlobalContext();
  const fetchDevices = useFetchDevices();
  const fetchOrders = useFetchOrders();

  const handleChange = async (api_key) => {
    setIsOrderLoading(true);
    setIsDeviceLoading(true);

    const new_account = state.account.pylo_accounts.find(
      (a) => a.api_key === api_key
    );
    localStorage.setItem('apiKeyName', new_account.name);
    setApiKey({ 
      name: new_account.name,
      key: api_key,
      key_id: new_account.key_id
    });
    fetchDevices(state.token, new_account['id']);
    fetchOrders(state.token, new_account['id']);
  };
  
  return (
    <ApiKeySelect
      account={state.account}
      value={state.apiKey?.key || ''}
      onChange={handleChange}
      usePyloAccounts={true}
    />
  );
};

export default ToggleDatabase;
